import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LayoutElementsEnum } from '../../../../layout/src/_interface/layoutElements.enum';
import * as fromLayoutActions from '../../../../layout/src/_actions/layout.actions';

@Injectable({
	providedIn: 'root'
})
export class ClickOutsideService {

	constructor(private store: Store) { }

	manageLayoutElements(element: string) {
		switch (element) {
			case LayoutElementsEnum.floatingSidebar:
				return this.store.dispatch(fromLayoutActions.closeFloatingSidebar());
			case LayoutElementsEnum.bottomBar:
				return this.store.dispatch(fromLayoutActions.closeBottomBar());
			case LayoutElementsEnum.patientCardVisible:
				return this.store.dispatch(fromLayoutActions.closePatientCard());
		}
	}
}
